import { render, staticRenderFns } from "./classifyDialog.vue?vue&type=template&id=5e74badc&scoped=true&"
import script from "./classifyDialog.vue?vue&type=script&lang=js&"
export * from "./classifyDialog.vue?vue&type=script&lang=js&"
import style0 from "./classifyDialog.vue?vue&type=style&index=0&id=5e74badc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e74badc",
  null
  
)

export default component.exports